import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
	preload(route: Route, load: () => Observable<any>): Observable<any> {
		// Preload only routes marked with data.preload = true
		return route.data && route.data['preload'] ? load() : of(null);
	}
}
